import { Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'

interface ISchoolLogoProps {
  school: ISchool | undefined
  logoOnly?: boolean
}

const WhiteTextTypography = withStyles({
  root: {
    // color: "#FFFFFF",
  },
})(Typography)

export function SchoolLogo(props: ISchoolLogoProps) {
  return props.school ? (
    <React.Fragment>
      <div
        title="School Logo"
        style={{
          padding: '5px',
          display: 'flex',
        }}
      >
        {props.school.logo ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              maxWidth: '50px',
              maxHeight: '30px',
              marginRight: '15px',
            }}
          >
            <img
              style={{ margin: '0px', maxHeight: '20px' }}
              src={props.school.logo}
            />
          </div>
        ) : null}
        {!props.logoOnly && props.school.name && (
          <div
            style={{
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <WhiteTextTypography variant="body1" style={{ fontWeight: 700 }}>
              {props.school.name}
            </WhiteTextTypography>
          </div>
        )}
      </div>
    </React.Fragment>
  ) : null
}
